export const BOARD_STAGES = ['Backlog', 'In progress', 'Review', 'Done'] as const;

export type BoardStage = (typeof BOARD_STAGES)[number];

export interface DemoBoardCard {
  id: string;
  title: string;
  chips: readonly string[];
  /** Column where this card lives when not being dragged by the demo. */
  homeStage: BoardStage;
}

export const MOVING_CARD_ID = 'custom-attrs';

export const MOVING_CARD: DemoBoardCard = {
  id: MOVING_CARD_ID,
  title: 'Spec custom-attributes UI',
  chips: ['Med'],
  homeStage: 'Backlog'
};

/** Cards that never change column during the FIG.02 loop. */
export const FIXED_BOARD_CARDS: readonly DemoBoardCard[] = [
  {
    id: 'auth-migrate',
    title: 'Migrate auth flow to Supabase',
    chips: ['High', 'LF'],
    homeStage: 'Backlog'
  },
  {
    id: 'onboarding',
    title: 'Sidepanel onboarding spec',
    chips: ['High', 'JL'],
    homeStage: 'In progress'
  },
  {
    id: 'pool-migration',
    title: 'Workspace pool migration',
    chips: ['Med', 'SK'],
    homeStage: 'Review'
  },
  {
    id: 'gallery',
    title: 'Gallery view for documents',
    chips: ['Low', 'MC'],
    homeStage: 'Done'
  }
];

export type CardsByStage = Record<BoardStage, DemoBoardCard[]>;

/**
 * Place the moving card in `movingStage`; fixed cards stay in their home columns.
 * Excludes the moving card from its home column when it is elsewhere (not needed
 * for the loop, but keeps lists consistent if homeStage is used as fallback).
 */
export function cardsByStage(movingStage: BoardStage): CardsByStage {
  const result: CardsByStage = {
    Backlog: [],
    'In progress': [],
    Review: [],
    Done: []
  };

  for (const card of FIXED_BOARD_CARDS) {
    result[card.homeStage].push(card);
  }

  result[movingStage].push({ ...MOVING_CARD, homeStage: movingStage });

  return result;
}
